'use client';

import { ReactNode, createContext, useContext } from 'react';
import { BrandTheme } from '@/lib/theme/brand-config';

interface ThemeContextType {
  theme: BrandTheme;
  contest: any;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

interface ThemeProviderProps {
  children: ReactNode;
  theme: BrandTheme;
  contest: any;
}

/**
 * Theme Provider
 * Provides theme and contest data to child components
 */
export function ThemeProvider({ children, theme, contest }: ThemeProviderProps) {
  return (
    <ThemeContext.Provider value={{ theme, contest }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}

